<template>
    <div class="modal fade" id="kt_modal_time_table" ref="timetableModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_add_customer_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <div class="modal-body py-10 px-lg-17">
                    <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                        <template v-if="form.data.student">
                            <h4 class="mb-7">{{ $t('pages.timetable.cols.student.title') }}</h4>
                            <div class="fv-row" :class="!form.data.student.avatar && 'mb-3'">
                                <label class="fs-5 fw-bold mb-2 me-2">{{ $t('pages.timetable.cols.student.cols.fullName') }}:</label>
                                <span class="text-gray-600 fw-bold fs-6">{{ form.data.student.full_name }}</span>
                            </div>

                            <div class="mb-7" v-if="form.data.student.avatar">
                                <label class="fs-5 fw-bold mb-2 me-2">{{ $t('pages.timetable.cols.student.cols.avatar') }}:</label>
                                <div>
                                    <a v-if="form.data.student.avatar.public_url" class="poster-image-show" :href="form.data.student.avatar.public_url" target="_blank">
                                        <div class="poster-image symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                            <img :src="form.data.student.avatar.thumb.small" alt="image">
                                            <span class="poster-image-overlay">
                                            <span class="poster-image-preview"><i class="bi bi-search"></i></span>
                                        </span>
                                        </div>
                                    </a>
                                    <div v-else class="poster-image symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                        <img src="/images/no-image.png" alt="image">
                                    </div>
                                </div>
                            </div>
                            <div class="fv-row chat-row" v-if="instructorCanChat.status">
                                <button class="btn btn-primary fw-bolder flex-shrink-0" @click="redirectPath(sprintf('/timetable/chat/%d', [form.data.id]))">
                                    <span class="svg-icon svg-icon-3 svg-icon-primary">
                                        <inline-svg src="/media/icons/duotune/communication/com007.svg"/>
                                    </span>
                                    {{ $t('pages.timetable.session.chat.title') }}
                                </button>
                            </div>
                            <div class="separator separator-dashed mb-7"></div>
                        </template>
                        <div class="fv-row mb-3" v-if="form.data.course">
                            <label class="fs-5 fw-bold mb-2 me-2">{{ $t('pages.timetable.cols.course') }}:</label>
                            <router-link :to="'/ecommerce/course?id=' + form.data.course.id" class="cursor-pointer text-gray-500 text-hover-primary me-2" target="_blank">
                                <span class="fw-bolder">{{ resolveDatum(form.data.course.translations, this.$root.defaultLanguage.id, 'language_id').title }}</span>
                            </router-link>
                        </div>
                        <div class="fv-row mb-3">
                            <label class="fs-5 fw-bold mb-2 me-2">{{ $t('pages.timetable.cols.startDate') }}:</label>
                            <span class="text-gray-600 fw-bold fs-6">{{ $moment(form.data.start_date).format("DD.MM.YYYY - HH:mm:ss") }}</span>
                        </div>
                        <div class="fv-row mb-3">
                            <label class="fs-5 fw-bold mb-2 me-2">{{ $t('pages.timetable.cols.endDate') }}:</label>
                            <span class="text-gray-600 fw-bold fs-6">{{ $moment(form.data.end_date).format("DD.MM.YYYY - HH:mm:ss") }}</span>
                        </div>
                        <div class="fv-row">
                            <div v-if="!session.loaded && canJoinSession" class="mt-7 mb-3">
                                <button @click="joinSession" :data-kt-indicator="session.loading ? 'on' : null" class="btn btn-success mt-7 mt-sm-0" type="button" :disabled="session.loading">
                                    <span v-if="!session.loading" class="indicator-label">{{ $t("pages.timetable.session.join") }}</span>
                                    <span v-if="session.loading" class="indicator-progress">
                                    {{ $t("messages.wait") }}
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                </button>
                            </div>
                            <template v-if="session.loaded">
                                <div class="separator separator-dashed mb-7"></div>
                                <h5 class="mb-6">{{ $t('pages.timetable.session.title') }}</h5>
                                <div class="">
                                    <h4 class="fs-5 fw-bold text-gray-800">{{ $t('pages.timetable.session.cols.joinUrl') }} </h4>
                                    <div class="d-flex">
                                        <input ref="inputRef" type="text" class="form-control form-control-solid me-3 flex-grow-1 cursor-pointer" v-model="session.data.join_url" @focus="copyJoinUrl(session.data.join_url)">
                                        <button class="btn btn-light fw-bolder flex-shrink-0" @click="trustedWindowOpen(session.data.join_url, '_blank')">{{ $t('pages.timetable.session.redirectJoinUrl') }}</button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="modal-footer align-items-center justify-content-between">
                    <button class="btn btn-danger fw-bolder flex-shrink-0" @click="redirectPath(sprintf('/timetable/document/%d', [form.data.id]))">
                        <span class="svg-icon svg-icon-3 svg-icon-primary">
                            <inline-svg src="/media/icons/duotune/communication/com007.svg"/>
                        </span>
                        {{ $t('pages.timetable.session.document.title') }}
                    </button>
                    <button class="btn btn-lg btn-primary" type="button" v-on:click="hideModal($refs.timetableModal)">{{ $t("btn.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return {
            form: {
                title: '',
                loading: false,
                data: {},
            },
            session: {
                loaded: false,
                loading: false,
                data: {},
            },
            instructorCanChat: {
                status: false,
            },
            redirectMode: {
                status: true,
                path: undefined
            }
        }
    },
    computed: {
        timetable() {
            return this.$store.state.ecommerce.course.session.table.data;
        },
        canJoinSession() {
            let status = false;

            if (this.form.data.start_date && this.form.data.end_date) {
                let now = this.$moment();
                let startTime = this.$moment(this.form.data.start_date).add(-10, 'minutes');
                let endTime = this.$moment(this.form.data.end_date).add(5, 'minutes');
                if (startTime <= now && endTime >= endTime) {
                    status = true;
                }
            }

            return status;
        }
    },
    methods: {
        openEvent(event) {
            this.form.title = this.$t('pages.timetable.programInformation');
            let filtered = this.timetable.filter((data) => data.id == event.id);

            if (filtered.length == 1) {
                let item = filtered[0];

                item.start_date = this.$moment(item.start_date).format('YYYY-MM-DD HH:mm:ss');
                item.end_date = this.$moment(item.end_date).format('YYYY-MM-DD HH:mm:ss');

                this.form.data = item;

                this.checkInstructorChat();

                let hiddenFunction = () => {
                    this.$refs.timetableModal.removeEventListener('hidden.bs.modal', hiddenFunction);
                    if (this.redirectMode.status) {
                        this.$router.push(this.redirectMode.path);
                    } else {
                        this.session.loaded = false;
                        this.session.data = {};
                        this.form.data = {};
                        this.form.show = false;
                    }
                };

                this.$refs.timetableModal.addEventListener('hidden.bs.modal', hiddenFunction);

                this.showModal(this.$refs.timetableModal);
            }
        },
        closeTimetableModal() {
            this.session.loaded = false;
            this.session.data = {};
            this.hideModal(this.$refs.timetableModal)
        },
        copyJoinUrl(url) {
            navigator.clipboard.writeText(url).then(() => {
                this.$refs.inputRef.disabled = true;
                this.$refs.inputRef.classList.add("bg-success");
                this.$refs.inputRef.classList.add("text-inverse-success");

                setTimeout(() => {
                    this.$refs.inputRef.disabled = false;
                    this.$refs.inputRef.classList.remove("bg-success");
                    this.$refs.inputRef.classList.remove("text-inverse-success");
                }, 3000); // 3seconds
            });
        },
        joinSession() {
            this.session.loading = true;
            this.axios.get(this.sprintf('%s/%d/join', [this.endpoint.get('ecommerce_course_session'), this.form.data.id])).then((response) => {
                let data = response.data.data;
                this.session.data = data;

            }).finally(() => {
                this.session.loading = false;
                this.session.loaded = true;
            });
        },
        checkInstructorChat() {
            this.instructorCanChat = { status: false };
            this.redirectMode = { status: false, path: undefined };

            this.axios.post(this.endpoint.get('ecommerce_course_session_chat_check'), {
                course_session_id: this.form.data.id
            }).then(response => {
                if (response.data && response.data.status && response.data.data.senderable) {
                    this.instructorCanChat.status = true;
                }
            });
        },
        redirectPath(path) {
            this.redirectMode = { status: true, path: path };
            this.hideModal(this.$refs.timetableModal);
        }
    }
}
</script>

<style>
.poster-image {
    border: 1px solid #c0ccda;
    border-radius: 6px;
}

.poster-image .poster-image-overlay {
    border-radius: 5px;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity 0.3s;
}

.poster-image .poster-image-overlay .poster-image-preview {
    margin-top: calc(50% - 21px);
    display: block;
}

.poster-image-show:hover .poster-image .poster-image-overlay {
    opacity: 1;
}

.chat-row {
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 1.75rem;
}
</style>